import { ProductSource, ProviderSource } from '@getvim-core-apps/organizations';
import {
  SourceConfig,
  SourceConfigurations,
  SourceConfigurationTypes,
  WidgetSource,
} from '../components/app/types/sourceConfigurations';

export const DEFAULT_MAPPING: SourceConfigurations = {
  supportIcdCpt: true,
  supportLanguage: true,
  supportDistance: true,
  supportOrdersButton: true,
  supportOrdersButtonInSignedReferralOnly: false,
  supportPlaceOfService: true,
  supportFacilityName: true,
  supportCost: false,
  supportWiderDistanceFilter: true,
  defaultDistanceFilter: 50,
  useSourceFreeText: false,
  supportInsurancePlanInput: false,
  supportNetworkInput: false,
  collapsePreferredProviders: false,
  supportReferralRequest: false,
  supportsAcceptingNewPatientsLongTooltip: false,
  maxCptsPerSearch: 3,
  resultsPerPage: 10,
  supportScoreRatingBadges: false,
  supportNetworkStatusBadge: false,
  supportOpeningHours: false,
  useGarnersSpecialtiesInput: false,
  useGenericSearchTitles: false,
  useGeoCoordinatesOnly: false,
  supportQuickSpecialties: true,
  supportAcceptingNewPatientsInCard: false,
  displayDistanceInExportDetails: false,
};

const configMapping: Map<WidgetSource, SourceConfig> = new Map([
  [
    ProductSource.BlueCrossBlueShield,
    {
      [SourceConfigurationTypes.AUTHENTICATED]: {
        ...DEFAULT_MAPPING,
        // When removing shouldFloridaBlueSupportFacility change here accordingly
        supportIcdCpt: false,
        supportOrdersButton: false,
        supportPlaceOfService: false,
        supportFacilityName: false,
        useSourceFreeText: true,
        supportReferralRequest: true,
      },
    },
  ],
  [
    ProductSource.UnitedHealthCare,
    {
      [SourceConfigurationTypes.AUTHENTICATED]: {
        ...DEFAULT_MAPPING,
        supportCost: true,
        supportWiderDistanceFilter: true,
        defaultDistanceFilter: 20,
        supportsAcceptingNewPatientsLongTooltip: true,
        maxCptsPerSearch: 1,
      },
    },
  ],
  [
    ProviderSource.TeladocGarner as WidgetSource,
    {
      [SourceConfigurationTypes.AUTHENTICATED]: {
        ...DEFAULT_MAPPING,
        supportIcdCpt: false,
        supportDistance: false,
        supportFacilityName: false,
        defaultDistanceFilter: 100,
        supportsAcceptingNewPatientsLongTooltip: true,
        resultsPerPage: 30,
        supportNetworkInput: true,
        supportPlaceOfService: false,
        supportScoreRatingBadges: true,
        supportNetworkStatusBadge: true,
        supportOpeningHours: true,
        useGarnersSpecialtiesInput: true,
        useGenericSearchTitles: true,
        useGeoCoordinatesOnly: true,
        supportQuickSpecialties: false,
        supportAcceptingNewPatientsInCard: true,
        displayDistanceInExportDetails: true,
        supportOrdersButtonInSignedReferralOnly: true,
      },
    },
  ],
  [
    ProductSource.Cigna,
    {
      [SourceConfigurationTypes.AUTHENTICATED]: {
        ...DEFAULT_MAPPING,
        supportIcdCpt: false,
        supportOrdersButton: false,
        supportPlaceOfService: false,
        supportFacilityName: false,
      },
    },
  ],
  [
    ProductSource.MockDemoInsurer,
    {
      [SourceConfigurationTypes.AUTHENTICATED]: {
        ...DEFAULT_MAPPING,
        supportIcdCpt: false,
        supportOrdersButton: false,
        supportPlaceOfService: false,
        supportFacilityName: false,
        supportReferralRequest: false,
      },
    },
  ],
]);

export default configMapping;
